import { ActionType, getType } from 'typesafe-actions';
import * as actions from '@actions/branding';
import { ResultState } from '@rootCommon/types/common';
import { FhqBranding, LogoRepositories } from '@rootCommon/types/branding';

type Action = ActionType<typeof actions>;
export type FhqBrandingState = ResultState<FhqBranding | null>;

const initState: FhqBrandingState = {
  data: null,
  loading: false,
  error: null,
};

export const fhqBrandingReducer = (state = initState, action: Action): FhqBrandingState => {
  switch (action.type) {
    // fetch
    case getType(actions.fetchFhqBranding.request):
      return { ...state, loading: true };
    case getType(actions.fetchFhqBranding.success):
      return { ...state, loading: false, data: action.payload };
    case getType(actions.fetchFhqBranding.failure):
      return { ...state, loading: false, error: action.payload };

      // update
    case getType(actions.updateFhqBranding.request):
      return { ...state, loading: true };
    case getType(actions.updateFhqBranding.success):
      return { ...state, loading: false, data: action.payload };
    case getType(actions.updateFhqBranding.failure):
      return { ...state, loading: false, error: action.payload };

      // delete
    case getType(actions.deleteFhqBranding):
      return {
        ...state,
        loading: false,
        data: state.data
          ? {
            ...state.data,
            [LogoRepositories.primaryLogoFileId]:
                              action.payload === state.data[LogoRepositories.primaryLogoFileId]
                                ? null
                                : state.data[LogoRepositories.primaryLogoFileId],
            [LogoRepositories.emailLogoFileId]:
                              action.payload === state.data[LogoRepositories.emailLogoFileId]
                                ? null
                                : state.data[LogoRepositories.emailLogoFileId],
          }
          : null,
      };

    default:
      return state;
  }
};

export default fhqBrandingReducer;
